import React from "react";
import {IconAlertTriangleFilled} from "@tabler/icons-react";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";
import {HHmmFormat} from "@commons/utils/util";

const AccumuliDiControllo: React.FC<{ totali: StatoWeekPLUSRecord | null, week?: StatoWeekPLUSRecord }> = ({totali, week}) => {
    /**
     * Se WEEK è valorizzata, sto visualizzando i dati SETTIMANALI,
     * altrimenti i totali MENSILI!
     */

    const accumuli = week ? week.accumuliCHK : totali?.accumuliCHK;
    const checkAccumuli = accumuli && accumuli.length > 0;

    return <table className="tableRiepiloghi fontTableRiepiloghi">
        <caption className="tableRiepiloghiCaption fontTableRiepiloghiCaption text-[15px]">
            Accumuli di controllo{/* {week ? 'settimana' : 'mese'}*/}
        </caption>
        {checkAccumuli && <thead>
        <tr className="tableRiepiloghiBorderB text-center">
            <th className="tableRiepiloghiBorderR text-right pr-2 w-2/5">Accumulo</th>
            <th className="tableRiepiloghiBorderR w-1/5">Periodo</th>
            <th className="tableRiepiloghiBorderR w-1/5">Criterio</th>
            <th className="tableRiepiloghiBorderR border-none w-1/5">Saldo</th>
        </tr>
        </thead>}

        <tbody>

        {/* SE NON HO NESSUN ACCUMULO ALL'INTERNO DELL'ARRAY */}
        {!checkAccumuli && <tr className="text-center">
            <td className="text-red-600 font-semibold col-span-full text-center">Informazioni non presenti.</td>
        </tr>}

        {checkAccumuli && accumuli?.map(accumulo => {

                //console.log('acc ', accumulo);

                return <tr key={accumulo.id}>
                    <td className="tableRiepiloghiLabelTD text-right  py-0.5">{AccumuloRecord.getDescrizione(accumulo)}</td>
                    <td className="tableRiepiloghiLabelTD text-center py-0.5">{!week ? (accumulo.periodo !== 'VALIDITA' ? accumulo.periodo : 'VALIDITA\'') : 'SETT.'}</td>
                    <td className="tableRiepiloghiLabelTD text-center py-0.5 text-nowrap">{AccumuloRecord.getCriterio(accumulo, false)}</td>


                    <td className="text-center py-0.5">
                      <span className="inline-flex">
                          {AccumuloRecord.applicaCriterio(accumulo, accumulo.saldoPeriodo) && <IconAlertTriangleFilled className="h-4 w-4 text-cyan-900"/>}&nbsp;

                          {HHmmFormat.format(accumulo.saldoPeriodo)}
                      </span>
                    </td>


                </tr>
            }
        )}
        </tbody>
    </table>
}

export default AccumuliDiControllo;